
const extractRepoDetails = (url) => {
  /**
   * Splits the URL for a GitHub repository into two parts:
   * - the repositoryName
   * - the userName
   */

  const prefix = "https://api.github.com/repos/";
  const parts = url.replace(prefix, "").split("/");

  return {
    repositoryName: parts[1],
    userName: parts[0]
  };
}


function formatDate(date) {
  var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return day + ' ' + monthNames[monthIndex] + ' ' + year;
}


export { extractRepoDetails, formatDate };
